import type MockAdapter from 'axios-mock-adapter'

import {mockStore} from '../mockStore'

import {sleepResponse} from './utils'

export const enableUpmEndpoints = (mock: MockAdapter) => {
  mock.onGet(new RegExp('/upm/plant')).reply(() => {
    const scenario = mockStore.scenario()
    const {
      burglengenfeld: {
        upm: {plants}
      }
    } = scenario
    return sleepResponse([200, plants])
  })
}
